<template>
  <div v-show="visible" class="plv-ia-message">{{ message }}</div>
</template>

<script>
export default {
  name: 'MessageMain',
  data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      timer: null,
      closed: false,
    };
  },

  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    }
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    close() {
      this.closed = true;
      this.$destroy(true);
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },

    clearTimer() {
      clearTimeout(this.timer);
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    }
  }
};
</script>
